// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Invoice_upper__Gd2b\\+ {
  display: grid;
  grid-template-columns: 72rem 1.5fr;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Invoice_upper__Gd2b\\+ {
    grid-template-columns: 60rem 1fr;
  }
}
@media only screen and (max-width: 56.25em) {
  .Invoice_upper__Gd2b\\+ {
    grid-template-columns: 100%;
  }
}
.Invoice_upper__ql__R8j39 {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  height: fit-content;
  align-self: center;
}
@media only screen and (max-width: 56.25em) {
  .Invoice_upper__ql__R8j39 {
    width: 95%;
    justify-self: center;
  }
}
.Invoice_upper__ql__content__Ac5yB {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  gap: 2rem;
  margin-top: 3rem;
}
.Invoice_upper__multiple__aD\\+dh {
  display: flex;
  flex-direction: column;
  border-radius: 2rem;
  background-color: var(--color-white);
  padding: 2rem;
}
.Invoice_upper__metrics__OlEPO {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .Invoice_upper__metrics__OlEPO {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .Invoice_upper__metrics__OlEPO {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Invoice_upper__metrics__OlEPO {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Invoice_upper__metrics_paid__w8pD4 {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Invoice_upper__metrics_unpaid__K-sIV {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Invoice_upper__metrics_partPaid__Jg9Z4 {
  background-color: var(--color-yellow);
}
.Invoice_upper__metrics_vat__oqubA {
  background-color: var(--color-light-red);
}
.Invoice_upper__metrics_discount__ORX0y {
  background-color: var(--color-primary-7);
}
.Invoice_upper__metrics_due__mp5zi {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Invoice_upper__metrics_owe__oT3I7 {
  background-color: var(--color-error);
  color: var(--color-white);
}

.Invoice_searchInMiddle__x2bdb {
  display: flex;
  width: 100%;
  justify-content: center;
}

.Invoice_invoice__list__n37TC {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Invoice_invoice__beside__y1ZH6 {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}
.Invoice_invoice__checks__2myL2 {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 38rem;
}
.Invoice_invoice__checks_group__c5Apd {
  align-self: center;
  width: 100%;
}

.Invoice_table__qu7ns {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Invoice_table__qu7ns th,
.Invoice_table__qu7ns td {
  padding: 2.2rem 0;
}
.Invoice_table__qu7ns th {
  font-weight: 700;
}
.Invoice_table__qu7ns tr {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;
  padding: 0 3rem;
}
@media only screen and (max-width: 37.5em) {
  .Invoice_table__qu7ns tr {
    grid-template-columns: 20% 50% 30%;
  }
}
.Invoice_table__qu7ns tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Invoice_table__qu7ns tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Invoice_table__qu7ns tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Invoice_table__qu7ns tbody tr > :last-child {
  display: flex;
  justify-content: space-between;
  font-size: var(--default-font-size);
}
@media only screen and (max-width: 37.5em) {
  .Invoice_table__qu7ns tbody tr > :last-child {
    font-size: var(--default-font-small);
  }
}
.Invoice_table__qu7ns tbody tr > :last-child > * {
  cursor: pointer;
}
.Invoice_table__qu7ns tbody tr > :last-child > *:hover {
  color: var(--color-primary);
}
.Invoice_table__qu7ns tbody tr > :nth-child(5) {
  font-size: 3rem;
  position: relative;
}
.Invoice_table__qu7ns tbody tr > :nth-child(5) span {
  font-size: 1.2rem;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Invoice_table__qu7ns tbody tr > :nth-child(5) span:hover {
  opacity: 1;
}

.Invoice_notPaid__kPzdw {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_draft__bcJ1M {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
  position: relative;
  top: 1rem;
}

.Invoice_partPaid__Gib1L {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_expired__SvxXR {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_paid__5IJo7 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_ordered__QN3dd {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Invoice_minMenu__\\+h1v9 {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 2rem;
}

.Invoice_sideButton__Kw1Hr {
  display: flex;
  margin-top: 3rem;
}

.Invoice_summary__nH3v3 {
  width: 42rem;
  margin-top: 2rem;
}
.Invoice_summary__title__z2RZ- {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Invoice_summary__initials__CyNRq {
  display: flex;
  background-color: var(--color-primary-7);
  font-size: var(--default-font-h3);
  font-weight: 700;
  width: 8rem;
  height: 8rem;
  border-radius: 8rem;
  justify-content: center;
  align-items: center;
}
.Invoice_summary__edit__PFPlo {
  display: flex;
  align-items: flex-end;
  color: var(--color-dark);
  font-size: var(--default-font-small);
  cursor: pointer;
  margin-bottom: 3rem;
}
.Invoice_summary__edit__PFPlo > :last-child {
  font-size: 3rem;
  color: var(--color-primary);
}
.Invoice_summary__edit__PFPlo:hover, .Invoice_summary__edit__PFPlo:focus {
  color: var(--color-primary-4);
  font-weight: 700;
}
.Invoice_summary__line__rhEwO {
  border-top: 1px solid var(--color-dark);
  margin: 2rem 0;
}
.Invoice_summary__dates__N0WSr {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Invoice_summary__dates__N0WSr > :not(:last-child) {
  margin-right: 2rem;
}
.Invoice_summary__total__ub4r8 {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.Invoice_summary__account__gM4RU {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}
.Invoice_summary__button__thaN5 {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-top: 2rem;
}

.Invoice_error__dIf0C {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.Invoice_select__ww0bi {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Invoice_select__ww0bi > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Invoice_select__invoice__qyUTR {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Invoice_select__invoice_b__MV0t8 {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Invoice_select__receipt__n\\+Ypx {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Invoice_select__receipt_b__WC\\+1\\+ {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.Invoice_selectCurrency__8og0S {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.Invoice_selectCurrency__text__7qDkA {
  display: flex;
  margin-left: 1rem;
}
.Invoice_selectCurrency__icon__iU24h {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.Invoice_selectCurrency__icon__iU24h:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Invoice_selectCurrency__icon_active__V7B9V {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Invoice_selectCurrency__list__KoU7o {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.Invoice_selectCurrency__list_active__9BL9c {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.Invoice_selectCurrency__list__KoU7o li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.Invoice_selectCurrency__list__KoU7o li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.Invoice_main__xpYD\\+ {
  display: grid;
  grid-template-columns: 72rem 1fr;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Invoice_main__xpYD\\+ {
    grid-template-columns: 56rem 1fr;
  }
}
@media only screen and (max-width: 43.75em) {
  .Invoice_main__xpYD\\+ {
    grid-template-columns: 100%;
  }
}
.Invoice_main_nav__aBLu\\+ {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 0 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Invoice_main_nav__aBLu\\+ > :not(:last-child) {
  margin-right: 3rem;
}
.Invoice_main_nav_group__Ui7tJ {
  position: relative;
}
.Invoice_main_nav_more__JU6Hi {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Invoice_main_nav_more__JU6Hi > :not(last-child) {
  margin-bottom: 1rem;
}
.Invoice_main_nav_item__PdYIx {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Invoice_main_nav_item_active__ruq3t {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.Invoice_main_nav_item__PdYIx:hover, .Invoice_main_nav_item__PdYIx:focus, .Invoice_main_nav_item__PdYIx:focus-visible, .Invoice_main_nav_item__PdYIx:focus-within {
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Invoice/Invoice.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,kCAAA;EACA,SAAA;AADD;AAGC;EALD;IAME,gCAAA;EAAA;AACF;AAEC;EATD;IAUE,2BAAA;EACA;AACF;AAOC;EACC,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AALF;AAOE;EAVD;IAWE,UAAA;IACA,oBAAA;EAJD;AACF;AAME;EACC,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAJH;AAQC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AANF;AASC;EACC,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAPF;AASE;EARD;IASE,qCAAA;EAND;AACF;AAQE;EAZD;IAaE,qCAAA;EALD;AACF;AAOE;EAhBD;IAiBE,qCAAA;EAJD;AACF;AAME;EACC,oCAAA;EACA,yBAAA;AAJH;AAOE;EACC,oCAAA;EACA,yBAAA;AALH;AAQE;EACC,qCAAA;AANH;AASE;EACC,wCAAA;AAPH;AAUE;EACC,wCAAA;AARH;AAWE;EACC,oCAAA;EACA,yBAAA;AATH;AAYE;EACC,oCAAA;EACA,yBAAA;AAVH;;AAeA;EACC,aAAA;EACA,WAAA;EACA,uBAAA;AAZD;;AAgBC;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;AAbF;AAgBC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAdF;AAiBC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;AAfF;AAiBE;EACC,kBAAA;EACA,WAAA;AAfH;;AAiCA;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AA9BD;AAgCC;;EAEC,iBAAA;AA9BF;AAiCC;EACC,gBAAA;AA/BF;AAkCC;EACC,aAAA;EACA,mDAAA;EACA,eAAA;AAhCF;AAkCE;EALD;IAME,kCAAA;EA/BD;AACF;AAmCE;EACC,qBAAA;AAjCH;AAoCE;EACC,wCAAA;EACA,qBAAA;AAlCH;AAoCG;EACC,wCAAA;AAlCJ;AAqCG;EACC,aAAA;EACA,8BAAA;EACA,mCAAA;AAnCJ;AAoCI;EAJD;IAKE,oCAAA;EAjCH;AACF;AAmCI;EACC,eAAA;AAjCL;AAkCK;EACC,2BAAA;AAhCN;AAqCG;EAWC,eAAA;EACA,kBAAA;AA7CJ;AA+CI;EACC,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AA7CL;AA+CK;EACC,UAAA;AA7CN;;AAqDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AAlDD;;AAsDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AAnDD;;AAsDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AAnDD;;AAqDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AAlDD;;AAqDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AAlDD;;AAoDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AAjDD;;AAoDA;EACC,2BAAA;EACA,eAAA;EACA,eAAA;AAjDD;;AAqDA;EACC,aAAA;EACA,gBAAA;AAlDD;;AAsDA;EACC,YAAA;EACA,gBAAA;AAnDD;AAoDC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAlDF;AAqDC;EACC,aAAA;EACA,wCAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAnDF;AAsDC;EACC,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;AApDF;AAsDE;EACC,eAAA;EACA,2BAAA;AApDH;AAuDE;EAEC,6BAAA;EACA,gBAAA;AAtDH;AA0DC;EACC,uCAAA;EACA,cAAA;AAxDF;AA2DC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAzDF;AA0DE;EACC,kBAAA;AAxDH;AA4DC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AA1DF;AA6DC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;AA3DF;AA8DC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AA5DF;;AAkEA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA/DD;;AAkEA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAhED;AAkEC;EACC,sBAAA;EACA,kBAAA;AAhEF;AAmEC;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAjEF;AAmEE;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAjEH;AAqEC;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAnEF;AAqEE;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAnEH;;AAwEA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AArED;AAuEC;EACC,aAAA;EACA,iBAAA;AArEF;AAwEC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AAtEF;AAwEE;EACC,4DACC;EAED,wCAAA;EACA,2BAAA;AAxEH;AA2EE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACC;EAED,wCAAA;EACA,2BAAA;AA3EH;AA+EC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACC;EAED,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AA/EF;AAiFE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AA/EH;AAkFE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAhFH;AAkFG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAhFJ;;AAsFA;EACC,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;AAnFD;AAqFC;EARD;IASE,gCAAA;EAlFA;AACF;AAoFC;EAZD;IAaE,2BAAA;EAjFA;AACF;AAmFC;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0CAAA;EACA,4BAAA;AAlFF;AAoFE;EACC,kBAAA;AAlFH;AAqFE;EACC,kBAAA;AAnFH;AAsFE;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AApFH;AAsFG;EACC,mBAAA;AApFJ;AAwFE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AAtFH;AA4FG;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AA1FJ;AA6FG;EAIC,gBAAA;EACA,2BAAA;EACA,6CAAA;AA9FJ","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\tdisplay: grid;\n\tgrid-template-columns: 72rem 1.5fr;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 60rem 1fr;\n\t}\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t// &__search {\n\t// \tgrid-column: 1/3;\n\t// \tgrid-row: 1/2;\n\t// \tjustify-self: center;\n\t// }\n\n\t&__ql {\n\t\twidth: 100%;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-white);\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tbox-sizing: border-box;\n\t\tpadding: 3.5rem 2rem;\n\t\theight: fit-content;\n\t\talign-self: center;\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\twidth: 95%;\n\t\t\tjustify-self: center;\n\t\t}\n\n\t\t&__content {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-evenly;\n\t\t\tbox-sizing: border-box;\n\t\t\tgap: 2rem;\n\t\t\tmargin-top: 3rem;\n\t\t}\n\t}\n\n\t&__multiple {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 2rem;\n\t}\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t&_paid {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_unpaid {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_partPaid {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\n\t\t&_vat {\n\t\t\tbackground-color: var(--color-light-red);\n\t\t}\n\n\t\t&_discount {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\n\t\t&_due {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_owe {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n}\n\n.searchInMiddle {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n}\n\n.invoice {\n\t&__list {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 38rem;\n\t\tflex-wrap: wrap;\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\t\twidth: 38rem;\n\n\t\t&_group {\n\t\t\talign-self: center;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n// .status {\n// \tcontent: none;\n// \twidth: 50%;\n// \tborder-radius: 1rem;\n// \tbackground-color: var(--color-yellow);\n// \tjustify-self: center;\n// \talign-self: center;\n// \tpadding: 3rem;\n// \tdisplay: block;\n// }\n\n//Table styles start\n\n.table {\n\twidth: 100%;\n\tmax-width: 100%;\n\tborder: none;\n\tborder-collapse: collapse;\n\tbox-sizing: border-box;\n\ttext-align: left;\n\tfont-size: var(--default-font-small);\n\n\tth,\n\ttd {\n\t\tpadding: 2.2rem 0;\n\t}\n\n\tth {\n\t\tfont-weight: 700;\n\t}\n\n\ttr {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;\n\t\tpadding: 0 3rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: 20% 50% 30%;\n\t\t}\n\t}\n\n\ttbody {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1.5rem;\n\t\t}\n\n\t\ttr {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tborder-radius: 1.3rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t}\n\n\t\t\t& > :last-child {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tfont-size: var(--default-font-size);\n\t\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\t}\n\n\t\t\t\t& > * {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& > :nth-child(5) {\n\t\t\t\t// content: none;\n\t\t\t\t// width: 3rem;\n\t\t\t\t// height: 3rem;\n\t\t\t\t// border-radius: 0.8rem;\n\n\t\t\t\t// justify-self: center;\n\t\t\t\t// align-self: center;\n\t\t\t\t// padding: 0;\n\t\t\t\t// margin-left: -2rem;\n\n\t\t\t\tfont-size: 3rem;\n\t\t\t\tposition: relative;\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: 1.2rem;\n\t\t\t\t\twidth: fit-content;\n\t\t\t\t\tbackground-color: rgba(0, 0, 0, 0.75);\n\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tpadding: 0.5rem;\n\t\t\t\t\tleft: -1.6rem;\n\t\t\t\t\tborder-radius: 0.5rem;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\topacity: 0;\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.notPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n\t// position: relative;\n\t// top: 1rem;\n}\n.draft {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n\tposition: relative;\n\ttop: 1rem;\n}\n\n.partPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n.expired {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n\n.paid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n.ordered {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n\n.minMenu {\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n\tfont-size: 2rem;\n}\n//Table styles end\n\n.sideButton {\n\tdisplay: flex;\n\tmargin-top: 3rem;\n}\n\n//Summary Styles\n.summary {\n\twidth: 42rem;\n\tmargin-top: 2rem;\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__initials {\n\t\tdisplay: flex;\n\t\tbackground-color: var(--color-primary-7);\n\t\tfont-size: var(--default-font-h3);\n\t\tfont-weight: 700;\n\t\twidth: 8rem;\n\t\theight: 8rem;\n\t\tborder-radius: 8rem;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t&__edit {\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tcolor: var(--color-dark);\n\t\tfont-size: var(--default-font-small);\n\t\tcursor: pointer;\n\t\tmargin-bottom: 3rem;\n\n\t\t& > :last-child {\n\t\t\tfont-size: 3rem;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: var(--color-primary-4);\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\n\t&__line {\n\t\tborder-top: 1px solid var(--color-dark);\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__dates {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 2rem;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&__total {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__account {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 1rem;\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__button {\n\t\tdisplay: flex;\n\t\tgap: 2rem;\n\t\talign-items: center;\n\t\tmargin-top: 2rem;\n\t}\n}\n\n//Errors\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n}\n\n.select {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t& > * {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__invoice {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__receipt {\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tmargin-left: 1rem;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow:\n\t\t\t\t10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow:\n\t\t\t\t10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow:\n\t\t\t10px 10px 45px #bebebe,\n\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.main {\n\tdisplay: grid;\n\tgrid-template-columns: 72rem 1fr;\n\talign-items: center;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 56rem 1fr;\n\t}\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 0 2rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-white);\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tborder-radius: 1rem 1rem 0 0;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 3rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t& > :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t// & > :nth-child(3) {\n\t// \tgrid-column: 1/3;\n\t// \tgrid-row: 2/3;\n\t// }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `Invoice_upper__Gd2b+`,
	"upper__ql": `Invoice_upper__ql__R8j39`,
	"upper__ql__content": `Invoice_upper__ql__content__Ac5yB`,
	"upper__multiple": `Invoice_upper__multiple__aD+dh`,
	"upper__metrics": `Invoice_upper__metrics__OlEPO`,
	"upper__metrics_paid": `Invoice_upper__metrics_paid__w8pD4`,
	"upper__metrics_unpaid": `Invoice_upper__metrics_unpaid__K-sIV`,
	"upper__metrics_partPaid": `Invoice_upper__metrics_partPaid__Jg9Z4`,
	"upper__metrics_vat": `Invoice_upper__metrics_vat__oqubA`,
	"upper__metrics_discount": `Invoice_upper__metrics_discount__ORX0y`,
	"upper__metrics_due": `Invoice_upper__metrics_due__mp5zi`,
	"upper__metrics_owe": `Invoice_upper__metrics_owe__oT3I7`,
	"searchInMiddle": `Invoice_searchInMiddle__x2bdb`,
	"invoice__list": `Invoice_invoice__list__n37TC`,
	"invoice__beside": `Invoice_invoice__beside__y1ZH6`,
	"invoice__checks": `Invoice_invoice__checks__2myL2`,
	"invoice__checks_group": `Invoice_invoice__checks_group__c5Apd`,
	"table": `Invoice_table__qu7ns`,
	"notPaid": `Invoice_notPaid__kPzdw`,
	"draft": `Invoice_draft__bcJ1M`,
	"partPaid": `Invoice_partPaid__Gib1L`,
	"expired": `Invoice_expired__SvxXR`,
	"paid": `Invoice_paid__5IJo7`,
	"ordered": `Invoice_ordered__QN3dd`,
	"minMenu": `Invoice_minMenu__+h1v9`,
	"sideButton": `Invoice_sideButton__Kw1Hr`,
	"summary": `Invoice_summary__nH3v3`,
	"summary__title": `Invoice_summary__title__z2RZ-`,
	"summary__initials": `Invoice_summary__initials__CyNRq`,
	"summary__edit": `Invoice_summary__edit__PFPlo`,
	"summary__line": `Invoice_summary__line__rhEwO`,
	"summary__dates": `Invoice_summary__dates__N0WSr`,
	"summary__total": `Invoice_summary__total__ub4r8`,
	"summary__account": `Invoice_summary__account__gM4RU`,
	"summary__button": `Invoice_summary__button__thaN5`,
	"error": `Invoice_error__dIf0C`,
	"select": `Invoice_select__ww0bi`,
	"select__invoice": `Invoice_select__invoice__qyUTR`,
	"select__invoice_b": `Invoice_select__invoice_b__MV0t8`,
	"select__receipt": `Invoice_select__receipt__n+Ypx`,
	"select__receipt_b": `Invoice_select__receipt_b__WC+1+`,
	"selectCurrency": `Invoice_selectCurrency__8og0S`,
	"selectCurrency__text": `Invoice_selectCurrency__text__7qDkA`,
	"selectCurrency__icon": `Invoice_selectCurrency__icon__iU24h`,
	"selectCurrency__icon_active": `Invoice_selectCurrency__icon_active__V7B9V`,
	"selectCurrency__list": `Invoice_selectCurrency__list__KoU7o`,
	"selectCurrency__list_active": `Invoice_selectCurrency__list_active__9BL9c`,
	"main": `Invoice_main__xpYD+`,
	"main_nav": `Invoice_main_nav__aBLu+`,
	"main_nav_group": `Invoice_main_nav_group__Ui7tJ`,
	"main_nav_more": `Invoice_main_nav_more__JU6Hi`,
	"main_nav_item": `Invoice_main_nav_item__PdYIx`,
	"main_nav_item_active": `Invoice_main_nav_item_active__ruq3t`
};
export default ___CSS_LOADER_EXPORT___;
